import React from "react";
import ProjectsSection from "../components/ProjectsSection/ProjectsSection";
import ProjectCard from "../components/ProjectsSection/ProjectCard";

const Projects: React.FC = () => {
  return (
    <>
      <ProjectsSection />
      <ProjectCard />
    </>
  );
};

export default Projects;
